const pathBase = "/organisations";

export const organisationsPath = () => pathBase;

export const organisationPath = (id?: number | string) =>
  id ? `${pathBase}/${id}` : null;
